import { IResponse } from "models";

export enum ActionType {
  FULL_STRESS_LAST_NOTIFICATION_TIME = "action/FULL_STRESS_LAST_NOTIFICATION_TIME",
  FULL_STRESS_LAST_NOTIFICATION_TIME_SUCCESS = "action/FULL_STRESS_LAST_NOTIFICATION_TIME_SUCCESS",
  FULL_STRESS_LAST_NOTIFICATION_TIME_ERROR = "action/FULL_STRESS_LAST_NOTIFICATION_TIME_ERROR",
  FULL_STRESS_LAST_NOTIFICATION_TIME_RESET = "action/FULL_STRESS_LAST_NOTIFICATION_TIME_RESET",
}

export interface Action<T> {
  type: ActionType;
  payload: T;
}

export interface IFullStressLastNotificationTimeResponse extends IResponse {
  result: {
    last_reminder_notification_at: string;
  };
}
